// Copyright (c) Ping. All rights reserved.

import type { LeaderboardEntry, LeaderboardSort } from './types';

/**
 * Pure comparator-based sort. Null values always order *after* concrete
 * values regardless of direction (per Figma — empty cells stay at the
 * bottom). Returns a new array; never mutates input.
 */
export function sortEntries(
  entries: readonly LeaderboardEntry[],
  sort: LeaderboardSort | null,
): readonly LeaderboardEntry[] {
  if (sort === null) {
    return entries;
  }
  const copy = entries.slice();
  copy.sort((a, b) => {
    const av = a.values.get(sort.columnId) ?? null;
    const bv = b.values.get(sort.columnId) ?? null;
    if (av === null && bv === null) {
      return 0;
    }
    if (av === null) {
      return 1;
    }
    if (bv === null) {
      return -1;
    }
    let cmp: number;
    if (typeof av === 'number' && typeof bv === 'number') {
      cmp = av - bv;
    } else {
      cmp = String(av).localeCompare(String(bv));
    }
    return sort.direction === 'ascending' ? cmp : -cmp;
  });
  return copy;
}
